import React, { useState } from 'react'
import Button from 'design-system/button'
import { ButtonSizes } from 'design-system/button/src/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

import { RequestNewCourseModal } from './componets/RequestNewCourseModal'
import { prefix } from './constants'
import styles from './RequestNewCourse.module.scss'

interface RequestNewCourseProps {
  onSuccess?(): void
}

export const RequestNewCourse: React.FC<RequestNewCourseProps> = ({
  onSuccess,
}) => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)
  const handleShow = () => setShow(true)
  return (
    <>
      <Button
        size={ButtonSizes.Small}
        className={styles.button}
        onClick={handleShow}
      >
        <FontAwesomeIcon className={styles.icon} icon={faPlus} />
        {t(`${prefix}.title`)}
      </Button>
      <RequestNewCourseModal
        show={show}
        onClose={() => {
          setShow(false)
        }}
        onSuccess={onSuccess}
      />
    </>
  )
}

export default RequestNewCourse
